import React, { useState, useEffect } from "react";
import {
  Typography,
  Grid,
  Card,
  CardContent,
  Button,
  Box,
} from "@mui/material";
import { List, ListItem, ListItemText } from "@mui/material";
import FileUploader from "./FileUploader";
import { addTaskThread, getTaskThread } from "../../services/taskService";
import "./style.css";
import { formatDate, hasPermission } from "../../utils/commonutils";
import { FilePreviewDrawer } from "./FilePreview";
import { getApiErrorMessage, isApiSuccess } from "../../utils/apiErrors";

function TaskThread({
  threads,
  customerId,
  thisEvt,
  taskId,
  employeeId,
  props,
}) {
  const [addText, setAddText] = useState("");
  const [addFiles, setAddFiles] = useState([]);
  const [threadData, setThreadData] = useState([]);
  const [showFollowup, setShowFollowup] = useState(false);
  const [resetUploader, setResetUploader] = useState(false);
  const [followupType, setFollowupType] = useState("");
  const [followupDate, setFollowupDate] = useState("");
  const [followupTime, setFollowupTime] = useState("");
  const [previewDoc, setPreviewDoc] = useState(null);
  const [textError, setTextError] = useState("");
  const handleUploadSuccess = (fileId) => {
    setAddFiles((prev) => [...prev, fileId]);
  };

  const handleDeleteSuccess = (fileId) => {
    setAddFiles((prev) => prev.filter((id) => id !== fileId));
  };

  const addThread = async () => {
    try {
      if (!addText.trim()) {
        setTextError("Description is required");
        return;
      }
      setTextError("");
      const data = {
        taskId,
        text: addText,
        createdBy: employeeId,
        files: addFiles,
        ...(showFollowup && {
          followupType,
          followupDate,
          followupTime,
        }),
      };

      const thread = await addTaskThread(thisEvt?.props, data);
      if (!isApiSuccess(thread)) {
        setTextError(getApiErrorMessage(thread, "Could not add thread"));
        return;
      }
      getThreads();
      setAddText("");
      setAddFiles([]);
       setResetUploader(prev => !prev);
      setShowFollowup(false);
      setFollowupType("");
      setFollowupDate("");
      setFollowupTime("");
    } catch (error) {
      console.log("error in add thread:", error);
      setTextError(getApiErrorMessage(error, "Could not add thread"));
    }
  };

  const getThreads = async () => {
    try {
      const threads = await getTaskThread(thisEvt?.props, { taskId });
      if (threads?.data?.taskThreads) {
        setThreadData(threads.data.taskThreads);
      }
    } catch (error) {
      console.log("Error getting threads:", error);
    }
  };

  useEffect(() => {
    getThreads();
  }, []);

  useEffect(() => {
    setThreadData(threads);
  }, [threads]);

  return (
    <Card>
      <CardContent>
        {hasPermission("create_taskthread") && (
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <p className="small-text">Thread Description</p>
              <textarea
                className={`input-main textarea${textError ? " input-main-error" : ""}`}
                value={addText}
                name="addText"
                rows="2"
                onChange={(e) => {
                  setAddText(e.target.value);
                  if (textError) setTextError("");
                }}
              />
              {textError ? <p className="error-message">{textError}</p> : null}
            </Grid>

            <Grid item xs={12}>
              <FileUploader
                onUploadSuccess={handleUploadSuccess}
                onDeleteSuccess={handleDeleteSuccess}
                thisEvt={thisEvt}
                customerId={customerId}
                files={addFiles}
                resetUploader={resetUploader}
                props={props || thisEvt?.props}
                label="Attach file"
              />
            </Grid>

            <Grid item xs={12} style={{ textAlign: "right" }}>
              <Button className="btn btn-colored" onClick={addThread}>
                Submit
              </Button>
            </Grid>
          </Grid>
        )}

        {/* Thread list */}
        {hasPermission("read_taskthread") && (
          <div className="task-thread-container">
            <List>
              {threadData?.map(
                (thread, index) =>
                  thread?.createdBy && (
                    <Box className="TaskthreadBox">
                      <ListItemText
                        primary={
                          <Typography sx={{ fontWeight: 500 }}>
                            {thread.text}
                          </Typography>
                        }
                        secondary={
                          <>
                            {thread.files?.length > 0 && (
                              <div style={{ marginTop: 6 }}>
                                {thread.files.map((file, i) => (
                                  <Box
                                    key={file?._id || i}
                                    display="flex"
                                    alignItems="center"
                                    gap={1}
                                    mb={0.5}
                                  >
                                    <span
                                      style={{
                                        cursor: "pointer",
                                        color: "#1a3366",
                                        fontSize: 13,
                                        fontWeight: 600,
                                      }}
                                      onClick={() => setPreviewDoc(file)}
                                    >
                                      📎 {file.fileName}
                                    </span>
                                  </Box>
                                ))}
                              </div>
                            )}
                          </>
                        }
                      />
                      <Typography
                        variant="body3"
                        sx={{ color: "gray", marginTop: "5px" }}
                      >
                        {formatDate(thread.createdAt)}
                      </Typography>
                    </Box>
                  ),
              )}
            </List>
          </div>
        )}
      </CardContent>
      <FilePreviewDrawer document={previewDoc} onClose={() => setPreviewDoc(null)} />
    </Card>
  );
}

export default TaskThread;
